module.exports = __webpack_public_path__ + "static/img/MT.46690631.svg";